// extracted by mini-css-extract-plugin
module.exports = {"layout":"V_K","content":"V_m","title":"V_p","subtitle":"V_N","subtitleBold":"V_fb","apps":"V_fc","cardChat":"V_fd","chat":"V_ff","search":"V_fg","share":"V_fh"};